import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { ChargeWaiverRegistrationRepoImpl } from "domain/repository/ChargeWaiverRegistration/ChargeWaiverRegistrationRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { useChargeWaiverRegistrationTracked } from "presentation/store/ChargeWaiverRegistration/ChargeWaiverRegistrationProvider";
import { ChargeWaiverRegistrationVM } from "presentation/viewModel/ChargeWaiverRegistration/ChargeWaiverRegistrationVM";
import { useMemo } from "react";

export const useChargeWaiverRegistrationVM = () => {
    const [, setChargeWaiverRegistrationState] = useChargeWaiverRegistrationTracked();
    const chargeWaiverRegistrationVM = useMemo(() =>
        ChargeWaiverRegistrationVM({
            dispatch: [setChargeWaiverRegistrationState],
            repo: ChargeWaiverRegistrationRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
        }), [setChargeWaiverRegistrationState])

    return chargeWaiverRegistrationVM
}